import { SeqRef, MetaType, SnapType, SnapConfig, ReadAloud } from "../types"
import { actionCreatorGuard, reducerGuard } from "../reducers"
import { Program } from "../../../../types/gqlTypes/graphql"

const kind = "snaps"

export type Timeline = {
  name: string
  sequences: Array<SeqRef>
}

type BranchMap = { [k: string]: Array<SeqRef> }

export type Snap = {
  kind: typeof kind
  version: number
  name: string
  type: SnapType
  program: Program | "STAARv2"
  subject: string
  level?: string
  isAllowedInContentLibrary?: boolean
  adaptive: boolean
  // timelines?: any
  branches: BranchMap
  branchOrder: Array<string>
  globalConfig: SnapConfig
  published: boolean
  readAloud?: ReadAloud
  description: string
  meta: MetaType
  contentType?: string
  contentId?: string
}

export const reducerAction = {
  meta: actionCreatorGuard<Snap, MetaType>("meta", kind),
  branches: actionCreatorGuard<Snap, BranchMap>("branches", kind),
  branchOrder: actionCreatorGuard<Snap, Array<string>>("branchOrder", kind),
  globalConfig: actionCreatorGuard<Snap, SnapConfig>("globalConfig", kind),
  published: actionCreatorGuard<Snap, boolean>("published", kind),
  readAloud: actionCreatorGuard<Snap, ReadAloud>("readAloud", kind),
  name: actionCreatorGuard<Snap, string>("name", kind),
  description: actionCreatorGuard<Snap, string>("description", kind),
  type: actionCreatorGuard<Snap, string>("type", kind),
  program: actionCreatorGuard<Snap, Program | "STAARv2">("program", kind),
  subject: actionCreatorGuard<Snap, string>("subject", kind),
  level: actionCreatorGuard<Snap, string>("level", kind),
  isAllowedInContentLibrary: actionCreatorGuard<Snap, boolean>(
    "isAllowedInContentLibrary",
    kind
  ),
  adaptive: actionCreatorGuard<Snap, boolean>("adaptive", kind),
  contentType: actionCreatorGuard<Snap, string>("contentType", kind),
  contentId: actionCreatorGuard<Snap, string>("contentId", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<Snap, "kind" | "version">]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapReducer = reducerGuard<Snap>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.branches)
  .case(...reducerAction.published)
  .case(...reducerAction.readAloud)
  .case(...reducerAction.name)
  .case(...reducerAction.description)
  .case(...reducerAction.branchOrder)
  .case(...reducerAction.globalConfig)
  .case(...reducerAction.program)
  .case(...reducerAction.subject)
  .case(...reducerAction.level)
  .case(...reducerAction.isAllowedInContentLibrary)
  .case(...reducerAction.adaptive)
  .case(...reducerAction.contentType)
  .case(...reducerAction.contentId)
  .build()
